/** Words used by shared pieces: the pop-up messages and the "viewing the past" banner. */

// ---- pop-up messages (toasts)
/** Hover and screen-reader label of the close button on a pop-up message. */
export const TOAST_DISMISS_LABEL = "Dismiss";
/** The close button's symbol. */
export const TOAST_DISMISS_SYMBOL = "×";

// ---- "viewing the past" banner ({when} = date and time, {seq} = change number, {total} = all changes)
/** Bold title of the banner. */
export const ASOF_TITLE = "Viewing the past";
/** Sentence when the view is at a saved change. */
export const ASOF_AT_CHANGE_TEXT = "as of {when}, change {seq} of {total}.";
/** Sentence when the view is before any change. */
export const ASOF_BEFORE_ANY_TEXT = "before any changes.";
/** Added after the sentence; says why nothing can be edited. Empty hides it. */
export const ASOF_EDITING_OFF_TEXT = "Editing is off.";
/** Button that goes back to the present. */
export const ASOF_RETURN_BUTTON = "Return to now";
